import { Button, Form, Input, Skeleton } from 'antd';
import React from 'react';
import { useMutation } from 'react-relay';
import { v4 as uuidv4 } from 'uuid';

import CreateCommentMutation from '../../graphql/mutations/CreateCommentMutation';
import { CommentType } from '../../types';
import Comments from '../Comments/Comments';

interface ICommentsForm {
    comments: CommentType[];
    connectionId: string;
    model_id: string;
    model_type: string;
    refreshData: Function;
    isDragging?: boolean;
    isAccess: { create?: boolean };
}

const CommentsForm: React.FC<ICommentsForm> = ({
    comments,
    connectionId,
    model_id,
    model_type,
    refreshData,
    isDragging,
    isAccess,
}) => {
    const [form] = Form.useForm();
    const [commit, isInFlight] = useMutation(CreateCommentMutation);

    const handleSubmit = (values: { comment: string }) => {
        commit({
            variables: {
                input: {
                    model_id: model_id,
                    model: model_type,
                    text: values.comment,
                },
                connections: [connectionId],
            },
            onCompleted: () => {
                form.resetFields();
                refreshData();
            },
        });
    };

    return (
        <div>
            {isAccess.create && (
                <Form name={`commentForm${uuidv4()}`} layout="vertical" form={form} onFinish={handleSubmit}>
                    <Form.Item
                        name="comment"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your comment!',
                            },
                        ]}
                    >
                        <Input.TextArea rows={3} placeholder="Add a comment..." />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" loading={isInFlight} style={{ marginTop: 12 }}>
                            Add Comment
                        </Button>
                    </Form.Item>
                </Form>
            )}
            {!isDragging ? <Comments comments={comments} /> : <Skeleton active />}
        </div>
    );
};

export default CommentsForm;
